export default "__VITE_ASSET__Cb9v3tqH__"